import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowUpSVG } from 'assets/images/home/arrow-up.svg';
import { ReactComponent as ArrowDownSVG } from 'assets/images/home/arrow-down.svg';

const ButtonWrapper = styled.div`
    width: 100%;
    position: relative;
    margin-bottom: 16px;
`;

const ExpandButton = styled.button<{ isExpanded: boolean }>`
    width: 100%;
    height: 40px;
    background: transparent;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 8px;
    position: relative;

    svg {
        width: 38px;
        height: 38px;
        animation: breathe 2s ease-in-out infinite;
    }

    @keyframes breathe {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        width: calc(50% - 20px);
        height: 1px;
        background: linear-gradient(-90deg, #f7931a 0%, #f7931a00 100%);
    }

    &::before {
        right: calc(50% + 40px);
    }

    &::after {
        left: calc(50% + 40px);
        transform: rotate(180deg);
    }

    &:hover {
        opacity: 0.8;
    }
`;

const Content = styled.div<{ isExpanded: boolean }>`
    display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};
`;

interface ExpandableSectionProps {
    children: React.ReactNode;
    defaultExpanded?: boolean;
    buttonText?: {
        expanded: string;
        collapsed: string;
    };
}

export default function ExpandableSection({ children, defaultExpanded = true }: ExpandableSectionProps) {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <div>
            <ButtonWrapper>
                <ExpandButton onClick={() => setIsExpanded(!isExpanded)} isExpanded={isExpanded}>
                    {isExpanded ? <ArrowUpSVG /> : <ArrowDownSVG />}
                </ExpandButton>
            </ButtonWrapper>
            <Content isExpanded={isExpanded}>{children}</Content>
        </div>
    );
}
